import { render, staticRenderFns } from "./propertyproblemmodal.vue?vue&type=template&id=3090fb13&scoped=true&"
import script from "./propertyproblemmodal.vue?vue&type=script&lang=js&"
export * from "./propertyproblemmodal.vue?vue&type=script&lang=js&"
import style0 from "./propertyproblemmodal.vue?vue&type=style&index=0&id=3090fb13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3090fb13",
  null
  
)

export default component.exports